import React, { useRef } from "react";
import Slider from "react-slick";
import { Box, Typography, Paper, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Approval() {
  const sliderRef = useRef(null);

  const approvals = [
    { title: "BHEL Approval", image: "/ntpc-approval.png" },
    { title: "IOCL Approval", image: "/IOCL.png" },
    { title: "NTPC Approval", image: "/bhel-approval.png" },
    { title: "BHEL Approval", image: "/ntpc-approval.png" },
    { title: "IOCL Approval", image: "/IOCL.png" },
    { title: "NTPC Approval", image: "/bhel-approval.png" },
  ];

  const settings = {
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Box
      component="section"
      id="approval"
      sx={{
        backgroundColor: "#F7FAFF",
        py: 10,
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {/* ================= OUTER WIDTH CONTROL ================= */}
      <Box sx={{ px: { xs: 2, sm: 4, md: "250px" } }}>
        
        {/* ================= HEADING ================= */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            component="h1"
            sx={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2d2075",
              lineHeight: 1.5,
              mb: 1,
            }}
          >
             Few Approvals
          </Typography>

          <Box
            sx={{
              width: 90,
              height: "3px",
              backgroundColor: "#2d2075",
              borderRadius: "2px",
              mx: "auto",
            }}
          />
        </Box>

        {/* ================= WHITE BACKGROUND BOX ================= */}
        <Paper
          elevation={3}
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "2px",
            p: { xs: 3, sm: 4, md: 5 },
            position: "relative",
          }}
        >
          <IconButton
  onClick={() => sliderRef.current?.slickPrev()}
  sx={{
    position: "absolute",
    left: -50,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    width: 44,
    height: 44,
    backgroundColor: "#ffffff",
    borderRadius: "50%", 
    boxShadow: "0 4px 12px rgba(0,0,0,.25)",
    color: "#2d2075",
    "&:hover": {
      backgroundColor: "#2d2075",
      color: "#ffffff",
    },
  }}
>
  <ArrowBackIosNewIcon fontSize="small" />
</IconButton>


          <IconButton
  onClick={() => sliderRef.current?.slickNext()}
  sx={{
    position: "absolute",
    right: -50,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    width: 44,
    height: 44,
    backgroundColor: "#ffffff",
    borderRadius: "50%", 
    boxShadow: "0 4px 12px rgba(0,0,0,.25)",
    color: "#2d2075",
    "&:hover": {
      backgroundColor: "#2d2075",
      color: "#ffffff",
    },
  }}
>
  <ArrowForwardIosIcon fontSize="small" />
</IconButton>


          {/* ================= SLIDER ================= */}
          <Slider ref={sliderRef} {...settings}>
            {approvals.map((item, index) => (
              <Box key={index} sx={{ px: 2 }}>
                <Paper
                  elevation={2}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "2px",
                    maxWidth: 320,     // ✅ smaller card
                    mx: "auto",
                    textAlign: "center",
                    overflow: "hidden",
                  }}
                >
                  {/* IMAGE */}
                  <Box
                    sx={{
                      height: 200,     // ✅ reduced height
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 1.5,
                    }}
                  >
                    <img
                      src={item.image}
                      alt={`${item.title} certificate`}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  </Box>

                  {/* TITLE */}
                  <Box sx={{ p: 1.5 }}>
                    <Typography
                      component="p"
                      sx={{
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#2d2075",
                        lineHeight: 1.4,
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            ))}
          </Slider>
        </Paper>
      </Box>
    </Box>
  );
}
